import { Menu, Transition } from "@headlessui/react";
import { Fragment, ReactNode, useEffect, useState } from "react";
import { cn } from "../../lib/utils";

type menuItem = {
  title?: string;
  renderTitle?: () => ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
  selected?: boolean;
  subMenu?: menuItem[];
};

type SimpleMenuProps = {
  position?: "left" | "right";
  type?: "primary" | "neutral";
  title?: string;
  iconTitle?: ReactNode;
  className?: string;
  disabled?: boolean;
  button?: ReactNode;
  menu: menuItem[];
};

export default function SimpleMenu(props: SimpleMenuProps) {
  const [selectedMenuIndex, setSelectedMenuIndex] = useState<number>(-1);

  useEffect(() => {
    if (!open) {
      setTimeout(() => setSelectedMenuIndex(-1), 200);
    }
  }, []);

  if (props.menu.every((element) => !element)) {
    return <></>;
  }
  return (
    <Menu
      as="div"
      className={
        "place-self-center relative inline-block text-left " +
        (props.className ? props.className : "")
      }
    >
      {({ open }) => {
        return (
          <>
            {props.title && (
              <div>
                <Menu.Button
                  disabled={props.disabled}
                  className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-purple-500"
                >
                  {props.title && <span>{props.title}</span>}
                  {props.iconTitle && props.iconTitle}
                </Menu.Button>
              </div>
            )}
            {props.button && (
              <Menu.Button disabled={props.disabled} className={"h-full"}>
                {props.button}
              </Menu.Button>
            )}
            {!props.title && !props.button && (
              <Menu.Button
                disabled={props.disabled}
                className="rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-purple-500"
              >
                <span className="sr-only">Open options</span>
                {props.iconTitle}
              </Menu.Button>
            )}

            <Transition
              show={open}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                static
                className={
                  "transition origin-top-right z-10 absolute right--8 mt-2 min-w-56 w-fit rounded-md shadow-lg bg-white border border-border divide-y divide-gray-100 focus:outline-none " +
                  (!props.position || props.position == "left"
                    ? "-translate-x-full left-full"
                    : "")
                }
              >
                <div className="py-1 whitespace-nowrap">
                  {(
                    (selectedMenuIndex >= 0
                      ? props.menu[selectedMenuIndex].subMenu
                      : props.menu) || []
                  ).map(
                    (menuItem, index) =>
                      menuItem && (
                        <Menu.Item key={`menu-${index}`}>
                          {({ active }) => (
                            <a
                              onClick={(e) => {
                                if (menuItem.subMenu) {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setSelectedMenuIndex(index);
                                } else if (menuItem.onClick) {
                                  menuItem.onClick();
                                  setSelectedMenuIndex(-1);
                                }
                              }}
                              className={cn(
                                active
                                  ? "bg-gray-100 text-gray-900 cursor-pointer"
                                  : "text-gray-700",
                                "group flex items-center px-4 py-2 text-sm w-full",
                              )}
                            >
                              {menuItem.icon && menuItem.icon}
                              {menuItem.title}
                              {menuItem.renderTitle?.()}
                            </a>
                          )}
                        </Menu.Item>
                      ),
                  )}
                </div>
              </Menu.Items>
            </Transition>
          </>
        );
      }}
    </Menu>
  );
}
